import { Component, OnInit, Inject, LOCALE_ID } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { Gender } from '../gender';
import { Nationality } from '../nationality';
import { EtcStudentParentLanguage } from '../etc-student-parent-language';
import { Booking } from '../booking';
import { HttpService } from '../service/http.service';
import { LocaleService } from '../locale.service';
import * as moment from 'moment';
import { EtcParentalPermission } from '../etc-parental-permission';
import { Title } from '@angular/platform-browser';
import { FaviconService } from '../favicon.service';
import { ActivatedRoute } from '@angular/router';
import { LoginService } from '../security/login.service';

@Component({
  selector: 'app-etc-parental-permission',
  templateUrl: './etc-parental-permission.component.html',
  styleUrls: ['./etc-parental-permission.component.css']
})
export class EtcParentalPermissionComponent implements OnInit {

  permissionForm: FormGroup;
  genders: Gender[] = [];
  nationalities: Nationality[] = [];
  languages: EtcStudentParentLanguage[] = [];
  booking!: Booking;

  locale: any;

  constructor(
    @Inject(LOCALE_ID)
    public localeId: string,
    private httpService: HttpService,
    private builder: FormBuilder,
    private localeService: LocaleService,
    private titleService: Title,
    private favicon: FaviconService,
    private route: ActivatedRoute,
    private loginService: LoginService
  ) {
    this.loginService.activatedNavigationComponent = false;
    let uuid = this.route.snapshot.paramMap.get("uuid");
    this.httpService.getBookingByUuid(uuid!)
      .subscribe(res => this.booking = res);

    this.titleService.setTitle(
      this.localeService.setTitleLanguage(this.localeId)
    );
    this.favicon.lvi();

    this.locale = localeService.setCalendarLanguage(this.localeId);
    httpService.getGenders().subscribe(res => {
      this.genders = res;
      for (let gender of this.genders) {
        gender.name = this.toTitleCase(gender.name);
      }
      this.permissionForm.get("studentGender")!.setValue(this.genders[0]);
    });
    httpService.getNationalities().subscribe(res => {
      this.nationalities = res;
      for (let nationality of this.nationalities) {
        nationality.name = this.toTitleCase(nationality.name);
      }
      this.permissionForm.get("studentNationality")!.setValue(this.nationalities[0]);
    });
    httpService.getAllEtcStudentParentLanguages().subscribe(res => {
      this.languages = res;
      for (let language of this.languages) {
        language.name = this.toTitleCase(language.name);
      }
      this.permissionForm.get("studentFirstLanguage")!.setValue(this.languages[0]);
      this.permissionForm.get("parent1FirstLanguage")!.setValue(this.languages[0]);
      this.permissionForm.get("parent2FirstLanguage")!.setValue(this.languages[0]);
    });
    this.permissionForm = builder.group({
      studentFirstName: "",
      studentFamilyName: "",
      studentGender: null,
      studentNationality: null,
      studentFirstLanguage: null,
      studentDateOfBirth: moment().format("DD/MM/YYYY"),
      studentPassportNumber: "",
      studentPassportExpiryDate: moment().format("DD/MM/YYYY"),
      parent1Title: "",
      parent1FirstName: "",
      parent1FamilyName: "",
      parent1RelationshipToStudent: "",
      parent1FirstLanguage: null,
      parent1LevelOfEnglish: "",
      parent1Address: "",
      parent1MobileNumber: "",
      parent1Email: "",
      parent2Title: "",
      parent2FirstName: "",
      parent2FamilyName: "",
      parent2RelationshipToStudent: "",
      parent2FirstLanguage: null,
      parent2LevelOfEnglish: "",
      parent2Address: "",
      parent2MobileNumber: "",
      parent2Email: "",
      permitMedicalTreatment: false,
      confirmAllMedicalProblemDisclosure: false,
      extraMedicalProblemDetail: "",
      permitParticipationToJuniorActivity: false,
      confirm16To17ActivityConditions: false,
      allowPublishingPrintMaterial: false,
      allowPublishingSocialMedia: false,
      allowPublishingVideos: false,
      allowPublishingEtcWebsite: false,
      makeOwnTransportFromAccommodationToSchool: false,
      makeOwnTransportFromAndToAirport: false,
      allowPublicTransport: false,
      agreeToFollowAccommodationRules: false,
      stayInHomestayAccommodation: false,
      stayInResidentialAccommodation: false,
      stayInOwnAccommodation: false,
      ownAccommodationResponsibleName: "",
      ownAccommodationResponsibleBirthDate: moment().format("DD/MM/YYYY"),
      ownAccommodationResponsibleRelationshipToChild: "",
      ownAccommodationResponsibleAddress: "",
      ownAccommodationResponsiblePhoneNumber: "",
      ownAccommodationResponsibleEmail: "",
      lastTetanusInjectionDate: moment().format("DD/MM/YYYY"),
      allowJoiningClassWithOver18: false,
      allowGoingOutUnsupervised: false,
      doctorTitle: "",
      doctorFirstName: "",
      doctorFamilyName: "",
      doctorAddress: "",
      doctorPhoneNumber: "",
      doctorEmail: "",
      allowRegisteringChildWithDoctor: false,
      parentalResponsibleFullName: "",
      parentalResponsiblePhoneNumber: "",
      parentalResponsibleRelationshipToStudent: "",
      parentalResponsibleFullAddress: "",
      parentalSignature: "AAAAB3NzaC1yc2EAAAABIwAAAQEAklOUpkDHrfHY17SbrmTIpNLTGK9Tjom"
    });
  }

  ngOnInit() {
  }

  toTitleCase(str: string) {
    let firstLetter = str[0];
    let majLetter = firstLetter.toUpperCase();
    return str.replace(firstLetter, majLetter);
  }

  sendForm() {
    let parentalPermission = new EtcParentalPermission(
      this.permissionForm.value.studentFirstName,
      this.permissionForm.value.studentFamilyName,
      this.permissionForm.value.studentGender,
      this.permissionForm.value.studentNationality,
      this.permissionForm.value.studentFirstLanguage,
      moment(this.permissionForm.value.studentDateOfBirth).utc(true),
      this.permissionForm.value.studentPassportNumber,
      moment(this.permissionForm.value.studentPassportExpiryDate).utc(true),
      this.permissionForm.value.parent1Title,
      this.permissionForm.value.parent1FirstName,
      this.permissionForm.value.parent1FamilyName,
      this.permissionForm.value.parent1RelationshipToStudent,
      this.permissionForm.value.parent1FirstLanguage,
      this.permissionForm.value.parent1LevelOfEnglish,
      this.permissionForm.value.parent1Address,
      this.permissionForm.value.parent1MobileNumber,
      this.permissionForm.value.parent1Email,
      this.permissionForm.value.parent2Title,
      this.permissionForm.value.parent2FirstName,
      this.permissionForm.value.parent2FamilyName,
      this.permissionForm.value.parent2RelationshipToStudent,
      this.permissionForm.value.parent2FirstLanguage,
      this.permissionForm.value.parent2LevelOfEnglish,
      this.permissionForm.value.parent2Address,
      this.permissionForm.value.parent2MobileNumber,
      this.permissionForm.value.parent2Email,
      this.permissionForm.value.permitMedicalTreatment,
      this.permissionForm.value.confirmAllMedicalProblemDisclosure,
      this.permissionForm.value.extraMedicalProblemDetail,
      this.permissionForm.value.permitParticipationToJuniorActivity,
      this.permissionForm.value.confirm16To17ActivityConditions,
      this.permissionForm.value.allowPublishingPrintMaterial,
      this.permissionForm.value.allowPublishingSocialMedia,
      this.permissionForm.value.allowPublishingVideos,
      this.permissionForm.value.allowPublishingEtcWebsite,
      this.permissionForm.value.makeOwnTransportFromAccommodationToSchool,
      this.permissionForm.value.makeOwnTransportFromAndToAirport,
      this.permissionForm.value.allowPublicTransport,
      this.permissionForm.value.agreeToFollowAccommodationRules,
      this.permissionForm.value.stayInHomestayAccommodation,
      this.permissionForm.value.stayInResidentialAccommodation,
      this.permissionForm.value.stayInOwnAccommodation,
      this.permissionForm.value.ownAccommodationResponsibleName,
      moment(this.permissionForm.value.ownAccommodationResponsibleBirthDate).utc(true),
      this.permissionForm.value.ownAccommodationResponsibleRelationshipToChild,
      this.permissionForm.value.ownAccommodationResponsibleAddress,
      this.permissionForm.value.ownAccommodationResponsiblePhoneNumber,
      this.permissionForm.value.ownAccommodationResponsibleEmail,
      moment(this.permissionForm.value.lastTetanusInjectionDate).utc(true),
      this.permissionForm.value.allowJoiningClassWithOver18,
      this.permissionForm.value.allowGoingOutUnsupervised,
      this.permissionForm.value.doctorTitle,
      this.permissionForm.value.doctorFirstName,
      this.permissionForm.value.doctorFamilyName,
      this.permissionForm.value.doctorAddress,
      this.permissionForm.value.doctorPhoneNumber,
      this.permissionForm.value.doctorEmail,
      this.permissionForm.value.allowRegisteringChildWithDoctor,
      this.permissionForm.value.parentalResponsibleFullName,
      this.permissionForm.value.parentalResponsiblePhoneNumber,
      this.permissionForm.value.parentalResponsibleRelationshipToStudent,
      this.permissionForm.value.parentalResponsibleFullAddress,
      this.permissionForm.value.parentalSignature,
      this.booking
    );

    this.httpService.postEtcParentalPermission(parentalPermission)
      .subscribe(() => {
        console.log("success");
      });
  }

}
